import { useMemo } from 'react';
import classNames from 'classnames';

import { FormThemeProvider } from '../../contexts/FormTheme/FormThemeContext';
import { useFormController } from '../../hooks/useFormController';
import { getFormTheme } from '../../utilities/getFormTheme';
import { createCustomFieldFactory } from '../customFieldFactory';
import FieldWrapper from '../Shared/FieldWrapper';
import FormBody from './FormBody';
import { FormVariantProps } from './types';

const alignmentConfig = {
  'text-left': 'text-left',
  'text-center': 'text-center',
  'text-right': 'text-right',
};

const DefaultForm = ({ fields, router, onNextForm }: FormVariantProps) => {
  const controller = useFormController({ fields, router, onNextForm });
  const { formRef, customFormId, alignmentStyle, theme, formTheme } = controller;

  const fieldFactory = useMemo(() => createCustomFieldFactory(), []);
  const { backgroundColor } = getFormTheme(theme, formTheme);

  return (
    <FormThemeProvider theme={theme}>
      <div
        id={customFormId}
        ref={formRef}
        className={classNames(
          'rounded-3xl p-6 shadow-lg shadow-gray-100 md:p-12',
          backgroundColor,
          alignmentConfig[alignmentStyle as keyof typeof alignmentConfig]
        )}
      >
        <FormBody
          form={fields}
          controller={controller}
          fieldFactory={fieldFactory}
          fieldWrapperComponent={FieldWrapper}
        />
      </div>
    </FormThemeProvider>
  );
};

export default DefaultForm;
